// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"0a95906c","534":"744e4456","685":"de56b159","725":"0e3cefe9","816":"77c62a1b"}[chunkId] + ".chunk.css";
};